// 动态Title
function setMetaTitle(title) {
    document.title = title
    let mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
        let iframe = document.createElement('iframe')
        iframe.style.visibility = 'hidden'
            // 替换成站标favicon路径或者任意存在的较小的图片即可  
            // iframe.setAttribute('src', '../../favicon.ico')  
        let iframeCallback = function() {
            setTimeout(function() {
                iframe.removeEventListener('load', iframeCallback)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', iframeCallback)
        document.body.appendChild(iframe)

        appCmdApply('updateTitle')
            // 通知APP 更新 
    }
}

// URL参数解析
function GetRequest() {
    var url = window.location.hash
    var theRequest = new Object()
    if (url.indexOf("?") != -1) {
        var str = url.split('?')[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1])
        }
    }
    return theRequest
}

function isAndroid() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return 1;
    } else if (isiOS) {
        return 2;
    }
}

// function appCmdApply(cmd='close', param={}){
//   console.log('------cmd------', cmd);
//   let data = {
//     "cmd": cmd,
//     "param": param
//   }
//   let type = isAndroid();
//   try{
//     if ( type == 1){
//       // 安卓
//       helper.bridgeCmd(JSON.stringify(data))
//     }else if(type == 2){
//       // IOS
//       window.webkit.messageHandlers.bridgeCmd.postMessage(data)
//     }else {
//       console.log('cmd->', cmd)
//     }
//   }catch(e){
//     console.log(e)
//     if(e && cmd == 'goBack') {
//       window.history.go(-1);
//     } 
//   }
// }

/**
 * @method 
 * @param {string} cmd -- 命令
 * @param {object} param -- 参数
 * @param {string} cbn -- 回调方法名
 * @description 调用app
 */
const appCmdApply = (cmd = 'close', param = {}, cbn) => {
    console.log('------cmd------', cmd);
    let data = {
        cmd,
        param,
        cbn
    }
    let type = isAndroid();
    try {
        if (type == 1) {
            // 安卓
            helper.bridgeCmd(JSON.stringify(data))
        } else if (type == 2) {
            // IOS
            window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        } else {
            console.log('cmd->', cmd)
        }
    } catch (e) {
        console.log('调试阶段不用管', e)
        if (e && cmd == 'goBack') {
            window.history.go(-1);
        }
    }
}

export {
    setMetaTitle,
    GetRequest,
    appCmdApply
}


// WEBPACK FOOTER //
// ./src/utils/utils.js